var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Shape from './Shape';
import { getImage } from '../utils/imageLoader';
import { rectBBox, inBBox, alignBox } from '../utils/bbox';
var boxAlign = {
    xMinYMin: ['left', 'top'],
    xMidYMin: ['center', 'top'],
    xMaxYMin: ['right', 'top'],
    xMinYMid: ['left', 'middle'],
    xMidYMid: ['center', 'middle'],
    xMaxYMid: ['right', 'middle'],
    xMinYMax: ['left', 'bottom'],
    xMidYMax: ['center', 'bottom'],
    xMaxYMax: ['right', 'bottom'],
};
var shapeKeys = ['x', 'y', 'width', 'height', 'src'];
var Image = /** @class */ (function (_super) {
    __extends(Image, _super);
    function Image() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'image';
        _this.svgTagName = 'image';
        _this.fillAble = false;
        _this.strokeAble = false;
        _this.shapeKeys = shapeKeys;
        return _this;
    }
    Image.prototype.getAnimationKeys = function () {
        return __spreadArrays(_super.prototype.getAnimationKeys.call(this), ['x', 'y', 'width', 'height']);
    };
    Image.prototype.getDefaultAttr = function () {
        return __assign(__assign({}, _super.prototype.getDefaultAttr.call(this)), { x: 0, y: 0, width: 0, height: 0, fillOpacity: 1, strokeOpacity: 1 });
    };
    Image.prototype.brush = function (ctx) {
        var _this = this;
        var _a = this.attr, src = _a.src, preserveAspectRatio = _a.preserveAspectRatio;
        if (!src) {
            return;
        }
        var image = getImage(src, this.id, function () {
            _this.dirty();
        });
        if (image) {
            var _b = this._getImagePosition(image), x = _b.x, y = _b.y, width = _b.width, height = _b.height;
            if (width === 0 || height === 0) {
                return;
            }
            if (image.width && image.height && preserveAspectRatio !== 'none') {
                ctx.drawImage(image, 0, 0, image.width, image.height, x, y, width >= 0 ? width : image.width, height >= 0 ? height : image.height);
            }
            else {
                ctx.drawImage(image, x, y, width, height);
            }
        }
    };
    Image.prototype.isPointOnPath = function (x, y) {
        return inBBox(this.getBBox(), x, y);
    };
    Image.prototype.getSvgAttributes = function () {
        return __assign(__assign({}, _super.prototype.getSvgAttributes.call(this)), { x: this.attr.x, y: this.attr.y, width: this.attr.width, height: this.attr.height, 'xlink:href': this.attr.src, preserveAspectRatio: this.attr.preserveAspectRatio || 'none' });
    };
    Image.prototype.computeBBox = function () {
        var _a = this.attr, x = _a.x, y = _a.y, width = _a.width, height = _a.height;
        return rectBBox(x, y, width, height);
    };
    Image.prototype._getImagePosition = function (image) {
        var _a = this.attr, x = _a.x, y = _a.y, width = _a.width, height = _a.height, _b = _a.preserveAspectRatio, preserveAspectRatio = _b === void 0 ? 'none' : _b;
        if (!preserveAspectRatio || preserveAspectRatio === 'none' || !image.width || !image.height) {
            return { x: x, y: y, width: width, height: height };
        }
        var _c = boxAlign[preserveAspectRatio], align = _c[0], verticalAlign = _c[1];
        var imageWidth = image.width;
        var imageHeight = image.height;
        var outWidth = width;
        var outHeight = height;
        if (width / height > imageWidth / imageHeight) {
            outWidth = (height * imageWidth) / imageHeight;
        }
        else {
            outHeight = (width * imageHeight) / imageWidth;
        }
        var _d = alignBox({ x: x, y: y, width: width, height: height }, outWidth, outHeight, align, verticalAlign), imageX = _d.x, imageY = _d.y;
        return { x: imageX, y: imageY, width: outWidth, height: outHeight };
    };
    return Image;
}(Shape));
export default Image;
